export default "__VITE_ASSET__BRcYTQaJ__"